export default {
  headerTop: 'سجّل اهتمامك لنتصل بك',
  headerAldar: 'سجّل الآن',
  headerRegister: 'سجّل الآن',
  bannerTextOne: 'كل شئ',
  bannerTextTwo: 'ولكن عادية',
  registerStory:
    'يقدم جاردينيا باي أسلوب حياة فريد من نوعه في جزيرة ياس، حيث يمتلئ كل يوم بالنكهة. اكتشف شقق استوديو على الواجهة البحرية وشقق مكونة من 3 غرف نوم بأسعار تبدأ من 900 ألف درهم إماراتي ومنازل تاون هاوس بأسعار تبدأ من 5.5 مليون درهم إماراتي، وهي منازل تستحق أن تكون منتجعاً في مجتمع مصمم للمفاجأة.',
  registerButton: 'يسجل',
  welcomeHeading: 'مرحبًا بكم في منتجع العيش مع الذوق',
  welcomeContent:
    'استيقظ على مناظر الواجهة البحرية الملهمة، والديكورات الداخلية الرائعة وعالم من التجارب المدهشة، وكلها مليئة بالطاقة التي تتميز بها جزيرة ياس.',
  tabAmenity: 'سجّل الآن',
  tabSustain: 'سجّل الآن',
  tabLocation: 'سجّل الآن',
  amenityHeading: 'سجّل الآن',
  amenityContent: 'سجّل الآن',
  sustainHeading: 'سجّل الآن',
  sustainContent: 'سجّل الآن',
  locationHeading: 'سجّل الآن',
  locationContent: 'سجّل الآن',
  tabButton: 'يسجل',
  footerLink: '800 الدار | الدار.كوم',
};
